<template lang="pug">
v-layout(wrap)
  v-flex(xs6)
    v-text-field(
      v-model='model.slug',
      label='Транслит для сайта (оставьте пустым для автогенерации)'
    )
  v-flex(xs6)
    v-text-field(v-model='model.url', disabled, label='Ссылка на сайте')
</template>

<script>
export default {
  props: ['model'],
}
</script>
